"use client"

import { motion } from "framer-motion"
import { FaBuilding, FaMapMarkerAlt, FaCalendarAlt, FaStar } from "react-icons/fa"

const InfoGeneralBufete = ({ data }) => {
  console.log(data) 
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-8"
    >
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold mb-4">Sobre Nosotros</h2>
        <p className="text-gray-600 leading-relaxed mb-6">{data.description}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-3">
            <FaBuilding className="text-[var(--gold)]  text-xl" />
            <div>
              <p className="text-sm text-gray-500">Fundación</p>
              <p className="font-medium">{data.foundationYear}</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <FaMapMarkerAlt className="text-[var(--gold)]  text-xl" />
            <div>
              <p className="text-sm text-gray-500">Ubicación</p>
              <p className="font-medium">{data.location}</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <FaStar className="text-[var(--gold)]  text-xl" />
            <div>
              <p className="text-sm text-gray-500">Valoración</p>
              <p className="font-medium">{data.rating} de 5</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <FaCalendarAlt className="text-[var(--gold)]  text-xl" />
            <div>
              <p className="text-sm text-gray-500">Experiencia</p>
              <p className="font-medium">{new Date().getFullYear() - Number.parseInt(data.foundationYear)} años</p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <motion.div whileHover={{ y: -5 }} className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-lg font-semibold mb-2">Casos Exitosos</h3>
          <p className="text-3xl font-bold text-[var(--gold)] ">500+</p>
          <p className="text-sm text-gray-500">En los últimos 5 años</p>
        </motion.div>

        <motion.div whileHover={{ y: -5 }} className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-lg font-semibold mb-2">Clientes Satisfechos</h3>
          <p className="text-3xl font-bold text-[var(--gold)] ">1000+</p>
          <p className="text-sm text-gray-500">Confían en nosotros</p>
        </motion.div>

        <motion.div whileHover={{ y: -5 }} className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-lg font-semibold mb-2">Profesionales</h3>
          <p className="text-3xl font-bold text-[var(--gold)] ">{data.team.length}</p>
          <p className="text-sm text-gray-500">Expertos en diferentes áreas</p>
        </motion.div>
      </div>
    </motion.div>
  )
}

export default InfoGeneralBufete

